/**
 * 密碼原則（需與後端 rag_app.py 的 _password_policy_error 保持一致）：
 * 長度 ≥ 12 碼，且需涵蓋「大寫 / 小寫 / 數字 / 特殊符號」四類中的至少三類。
 */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MIN_CLASSES = 3;

export const PASSWORD_POLICY_TEXT =
  `密碼長度需至少 ${PASSWORD_MIN_LENGTH} 碼，且必須包含英文大寫字元、英文小寫字元、數字、` +
  `特殊符號四類中的至少 ${PASSWORD_MIN_CLASSES} 類`;

const SPECIAL_RE = /[!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]/;

/** 計算密碼涵蓋的字元類別數（0–4）。 */
export function passwordClassCount(password: string): number {
  return [/[A-Z]/, /[a-z]/, /[0-9]/, SPECIAL_RE].filter((re) => re.test(password)).length;
}

/** 檢查密碼是否符合原則；符合回傳 null，否則回傳中文錯誤訊息。 */
export function passwordPolicyError(password: string): string | null {
  if (!password) return '密碼不可為空';
  if (password.length < PASSWORD_MIN_LENGTH) return PASSWORD_POLICY_TEXT;
  if (passwordClassCount(password) < PASSWORD_MIN_CLASSES) return PASSWORD_POLICY_TEXT;
  return null;
}
